/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type SettlementLineDtoStatus = typeof SettlementLineDtoStatus[keyof typeof SettlementLineDtoStatus];


export const SettlementLineDtoStatus = {
  outstanding: 'outstanding',
  paid: 'paid',
  waived: 'waived',
  disputed: 'disputed',
} as const;
